import { getExtras } from "@/api/metrics";

export default {
  /**
   * Fetches the extras from the API,
   * Aggregations, Operations and Comparisons
   */
  fetchExtras: async ({ commit, state }) => {
    if (state.aggregations && state.operations && state.comparisons) {
      return null;
    }

    const response = await getExtras();
    const { data, status } = response;

    if (status === 200) {
      const { agg, operations, comparisons } = data;
      commit("SET_EXTRAS", {
        aggregations: agg,
        operations,
        comparisons,
      });
    } else {
      return null;
    }
  },
};
